"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toAPI = void 0;
function toAPI(query) {
    var id__in = query.id__in, title = query.title, title__in = query.title__in, message__icontains = query.message__icontains, is_read = query.is_read, level = query.level, terminal = query.terminal, limit = query.limit, offset = query.offset, rest = __rest(query, ["id__in", "title", "title__in", "message__icontains", "is_read", "level", "terminal", "limit", "offset"]);
    var result = __assign({}, rest);
    if (id__in && id__in.length > 0) {
        result.id__in = id__in.join(',');
    }
    if (title && title.length > 0) {
        if (typeof title === 'string') {
            result.title = title;
        }
        else {
            result.title__in = title.join(',');
        }
    }
    if (title__in && title__in.length > 0) {
        result.title__in = title__in.join(',');
    }
    if (message__icontains) {
        result.message__icontains = message__icontains;
    }
    if (is_read !== undefined) {
        result.is_read = String(is_read);
    }
    if (level) {
        result.level = level;
    }
    if (terminal) {
        result.terminal = terminal;
    }
    if (limit !== undefined) {
        result.limit = String(limit);
    }
    if (offset !== undefined) {
        result.offset = String(offset);
    }
    return result;
}
exports.toAPI = toAPI;
